import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../store';
import './smart-ready-modal.scss';
import { SmartReadyModalContent } from './smart-ready-modal-content';
import { ApplyingPolicyModalContent } from '../policy-modal/applying-policy-modal-content';
import { Modal } from 'antd';
import { SmartReadyPolicySummary } from './smart-ready-policy-summary';

interface SmartReadyModalProps {
    visible: boolean;
    setIsVisible: (visible: boolean) => void;
}

export const SmartReadyModal: React.FC<SmartReadyModalProps> = observer(({ visible, setIsVisible }) => {
    const { fwVersionStore } = useStores();
    const [isApply, setIsApply] = useState(false);
    const [displayPolicySummary, setDisplayPolicySummary] = useState(false);

    useEffect(() => {
        if (visible) {
            setIsApply(false);
            setDisplayPolicySummary(false);
        }
    }, [visible]);

    const closeModal = () => {
        setIsVisible(false);
    };
    
    const modalContent = useMemo(() => {
        if (isApply) {
            return <ApplyingPolicyModalContent onClickGotIt={closeModal}
                                               title={'Your Smart Protection policy is being applied'}/>;
        }
        if (displayPolicySummary) {
            return <SmartReadyPolicySummary closeModal={closeModal} setIsApply={setIsApply} selectedVersion={fwVersionStore.draftVersion} />;
        }
        return <SmartReadyModalContent setDisplayPolicySummary={setDisplayPolicySummary}/>;
    }, [isApply, displayPolicySummary, fwVersionStore.draftVersion]);

    const summaryIsDisplayed = useMemo(() => displayPolicySummary && !isApply, [displayPolicySummary, isApply]);

    return <Modal open={visible}
                  className={`policy-modal ${summaryIsDisplayed ? 'policy-summary':''}`}
                  width={summaryIsDisplayed? 816: 680}
                  closable={false}
                  footer={null}
                  centered>
        {modalContent}
    </Modal>;
});